import { render, staticRenderFns } from "./TextContentModal.vue?vue&type=template&id=557acf8e&scoped=true&"
import script from "./TextContentModal.vue?vue&type=script&lang=js&"
export * from "./TextContentModal.vue?vue&type=script&lang=js&"
import style0 from "./TextContentModal.vue?vue&type=style&index=0&id=557acf8e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "557acf8e",
  null
  
)

export default component.exports